import React from 'react'
import { Link } from 'react-router-dom'
import Text from '../elements/Typo/Text'
interface Props {
    label: string
    to: string
    active: boolean
    onClick?: (e: any) => void
}
const DashboardTabElement: React.FC<Props> = ({ label, to, onClick, active }) => {
    return (
        <Link to={to} onClick={onClick} className={`h-[2rem] flex items-center justify-center rounded-tl-[0.583rem] rounded-tr-[0.583rem] ${active ? 'bg-primary' : ''}`}>
            <Text size="xl" className={`!leading-none !font-normal px-3 !text-[0.864rem] ${active ? '' : '!text-[#707070]'}`}>
                {label}
            </Text>
        </Link>
    )
}

export default DashboardTabElement
